import React, { useState } from 'react';
import Fade from '@material-ui/core/Fade';
import Zoom from '@material-ui/core/Zoom';

import { Flex } from 'components/layout';

import { Emoji } from './Emoji';
import { EmojiSelector, ContentWrapper, RatingText } from './styledComponents';

const MAP_RATING_TO_EMOJI = {
  1: '😤',
  2: '☹️',
  3: '😐',
  4: '🙂',
  5: '🤩',
};

const MAP_RATING_TO_TEXT = {
  1: "I really don't like it",
  2: "I don't like it",
  3: "It's fine",
  4: 'I like it',
  5: 'I love it!',
};

const RatingSelector = ({
  selectedRating = null,
  showInitialMessage = true,
  onSelect,
}) => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [text, setText] = useState(null);

  const renderEmoji = (rating) => {
    const text = MAP_RATING_TO_TEXT[rating];

    return (
      <Emoji
        symbol={MAP_RATING_TO_EMOJI[rating]}
        label={text}
        onMouseEnter={() => setText(text)}
        onClick={() => {
          setText('');
          onSelect(rating);
        }}
      />
    );
  };

  const renderSelector = () => {
    const showSelector = selectorOpen || !showInitialMessage;
    return (
      <>
        {showSelector ? (
          <Zoom in={showSelector} timeout={250} unmountOnExit>
            <EmojiSelector multi>
              {renderEmoji(1)}
              {renderEmoji(2)}
              {renderEmoji(3)}
              {renderEmoji(4)}
              {renderEmoji(5)}
            </EmojiSelector>
          </Zoom>
        ) : null}
        {!showSelector ? (
          <Zoom in={!showSelector} timeout={250} unmountOnExit>
            <ContentWrapper padded>
              We <Emoji symbol={'💕'} label="Love" /> Feedback
            </ContentWrapper>
          </Zoom>
        ) : null}
      </>
    );
  };

  return (
    <Flex alignment="center">
      <Fade in={text !== ''} timeout={300}>
        <RatingText>{text}</RatingText>
      </Fade>
      <div
        onMouseEnter={() => setSelectorOpen(true)}
        onMouseLeave={() => {
          setSelectorOpen(false);
          setText('');
        }}
      >
        {selectedRating ? (
          <Fade in timeout={500}>
            <EmojiSelector>{renderEmoji(selectedRating)}</EmojiSelector>
          </Fade>
        ) : (
          renderSelector()
        )}
      </div>
    </Flex>
  );
};

export { RatingSelector };
